import { useMutation } from '@apollo/client';
import { graphql } from '@client/graphql/types';

const MUTATION = graphql(`
  mutation UpdatePrinterDevice($id: ID!, $data: UpdatePrinterDeviceInput!) {
    updatePrinterDevice(id: $id, data: $data) {
      id
    }
  }
`);

export function useUpdatePrinterDevice() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetEpsonServerDirectPrint'],
  });
}
